export default "__VITE_ASSET__A3t0Y1ua__"